import React,{useState, useEffect} from 'react';
import { TextField, Button, Typography, Paper, MenuItem  } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './styles';
import { createPost, updatePost } from '../../actions/posts';
import { useHistory } from 'react-router-dom';




const Form = ({ currentId, setCurrentId }) => {
    const classes = useStyles();
    
    const dispatch = useDispatch();
    const post = useSelector((state) => currentId ? state.posts.posts?.find((message) => message._id === currentId) : null );
    //const post = useSelector((state) => currentId ? (!state.posts.posts.find ? state.posts.posts.post : state.posts.posts.find((message) => message._id === currentId)) : null );
    const [postData, setPostData] = useState({
        title: '',description: '', pictureURL: '',price:'',category:'', city:''
    })
    const history = useHistory();
    const user = JSON.parse(localStorage.getItem('profile'));
    
    useEffect(() => {
        if(post) setPostData(post)
        if(!post) clear()
        
    }, [post])

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
          if (currentId === 0) {
            dispatch(createPost({...postData, username: user?.result?.username} , history));
            window.alert('You have succesfully created an Ad');
            setCurrentId(0);
            clear();
          } else {
            dispatch(updatePost(currentId, {...postData, username: user?.result?.username }));
            window.alert('Changes to an Ad were successful');
            setCurrentId(0);
            clear();
          }
          history.push('/')
        } catch (error) {
          window.alert(error)
        }
      };

      const clear = () => {
        setPostData({ title: '',description: '', pictureURL: '',price:'',category:'',city:'' });
      };

    return (
        <Paper className={classes.paper}>
            <form autoComplete="off"  className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
            <Typography variant="h6">{currentId ? "Edit Item" : "New Item"}</Typography>
            <TextField  required name="title" variant="outlined" label="Title" fullWidth value={postData.title} onChange={(e) => setPostData({ ...postData, title: e.target.value })} />
            <TextField  required name="description" variant="outlined" multiline={true} label="Description" fullWidth value={postData.description} onChange={(e) => setPostData({ ...postData, description: e.target.value })} />
            <TextField  name="pictureURL" variant="outlined" label="Picture" fullWidth value={postData.pictureURL} onChange={(e) => setPostData({ ...postData, pictureURL: e.target.value})} />
            <TextField  select name="category" variant="outlined" label="Category" fullWidth value={postData.category} onChange={(e) => setPostData({ ...postData, category: e.target.value})}>
                <MenuItem value={"Clothing"}>Clothing</MenuItem>
                <MenuItem value={"Tools"}>Tools</MenuItem>
                <MenuItem value={"Sports"}>Sports</MenuItem>
                <MenuItem value={"Accessories"}>Accessories</MenuItem>
                <MenuItem value={"Furniture"}>Furniture</MenuItem>
                <MenuItem value={"Pets"}>Pets</MenuItem>
                <MenuItem value={"Games"}>Games</MenuItem>
                <MenuItem value={"Books"}>Books</MenuItem>
                <MenuItem value={"Technology"}>Technology</MenuItem>
            </TextField>
            <TextField  required name="city" variant="outlined" label="City" fullWidth value={postData.city} onChange={(e) => setPostData({ ...postData, city: e.target.value })} />
            <TextField  required name="price" variant="outlined" label="Price" fullWidth value={postData.price} onChange={(e) => setPostData({ ...postData, price: e.target.value })} />
            <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth>Submit</Button>
            <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth>Clear</Button>
            
        </form>
    </Paper>
    )
}

export default Form
